
import { Component, Vue } from 'vue-property-decorator';
import DeviceLayout from '../../layouts/DeviceLayout.vue';
import PcVideoOnlyPage from '../../blocks/PcVideoOnlyPage.vue';
import MobilePage from '../../blocks/MobilePage.vue';
import { SO360_02_DOWNLOAD_URLS, S360_DOWNLOAD_CONFIGS } from '../../config/downloadUrls';
import { LandingProps, PcVideoOnlyProps } from '../../config/types';
import { setupPage } from '../../utils/setupPage';

const DEVELOPER_NAME = '上海益活网络科技有限公司';

@Component({
  components: { DeviceLayout, PcVideoOnlyPage, MobilePage },
})
export default class So36002Page extends Vue {
  public landingProps: LandingProps = {
    downloadUrls: SO360_02_DOWNLOAD_URLS,
    hideList: false,
    showAppInfo: true,
    isBaiduDeveloper: false,
    showAddress: false,
    developerName: DEVELOPER_NAME,
    so360DownloadConfig: S360_DOWNLOAD_CONFIGS.SO360_02,
  };

  get pcProps(): PcVideoOnlyProps {
    return {
      downloadUrls: this.landingProps.downloadUrls,
      showAppInfo: this.landingProps.showAppInfo,
      isBaiduDeveloper: this.landingProps.isBaiduDeveloper,
      showAddress: this.landingProps.showAddress,
      developerName: this.landingProps.developerName,
      so360DownloadConfig: this.landingProps.so360DownloadConfig,
      videoSrc: require('@/assets/video/rj01.mp4'),
    };
  }

  public mounted() {
    setupPage({
      documentTitle: DEVELOPER_NAME,
      so360Tracking: false,
    });
  }
}
